var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamsEmptyStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.103,
    height: 23,
    viewBox: "0 0 24.103 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8399",
    "data-name": "Rectangle 8399",
    width: 24.103,
    height: 23,
    fill: "#bfc2d6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16052",
    "data-name": "Group 16052",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5839",
    "data-name": "Path 5839",
    d: "M24.062,8.726h0a.812.812,0,0,0-.723-.561l-7.689-.491L12.808.514a.814.814,0,0,0-1.514,0L8.45,7.674.763,8.165A.814.814,0,0,0,0,9.03a.818.818,0,0,0,.293.575l5.93,4.916L4.317,21.985a.815.815,0,0,0,1.225.888l6.508-4.12,6.509,4.121a.805.805,0,0,0,.434.126.814.814,0,0,0,.791-1.015l-1.908-7.462,5.93-4.917a.81.81,0,0,0,.256-.879m-16.131,5.7a.817.817,0,0,0-.27-.829L2.913,9.66l6.156-.393a.817.817,0,0,0,.7-.512l2.277-5.733,2.277,5.733a.819.819,0,0,0,.7.512l6.155.393L16.439,13.6a.817.817,0,0,0-.27.829L17.7,20.4l-5.211-3.3a.818.818,0,0,0-.872,0L6.4,20.4Z",
    transform: "translate(0 0)",
    fill: "#bfc2d6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsEmptyStar);
export default __webpack_public_path__ + "static/media/teams-empty-star.00b5ff62d14837f62e04a988ef94da06.svg";
export { ForwardRef as ReactComponent };